export const companiesData = {
  "green-shield-canada": {
    companyName: "GreenShield",
    description:
      "Green Shield Canada (GSC) is a not-for-profit benefits carrier that provides drug, dental, extended health care, vision, hospital and travel benefits for groups and individuals, as well as administration services.",
    address: "8677 Anchor Drive, P.O Box 1606, Windsor, ON N9A 6W1",
    logo: "https://assets.greenshield.ca/greenshield/layout/logo_primary.png",
    industry: "Benefits Insurance",
    website: "https://www.greenshield.ca/en-ca",
    isHiring: true,
    images: [
      {
        src:
          "https://upload.wikimedia.org/wikipedia/commons/d/d3/Green_Shield_head_office_Windsor.jpg",
        thumbnail:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Green_Shield_head_office_Windsor.jpg/220px-Green_Shield_head_office_Windsor.jpg",
        thumbnailWidth: 120,
        thumbnailHeight: 120,
      },
      {
        src:
          "https://rosatigroup.com/wp-content/uploads/2019/09/Green-Shield-3.jpg",
        thumbnail: "/assets/images/companies/greenshield_tb_2.jpeg",
        thumbnailWidth: 120,
        thumbnailHeight: 120,
      },
      {
        src:
          "https://rosatigroup.com/wp-content/uploads/2019/09/Green-Shield-4.jpg",
        thumbnail:
          "https://rosatigroup.com/wp-content/uploads/2019/09/Green-Shield-4-150x150.jpg",
        thumbnailWidth: 120,
        thumbnailHeight: 120,
      },
      {
        src:
          "https://rosatigroup.com/wp-content/uploads/2019/09/Green-Shield-1.jpg",
        thumbnail:
          "https://rosatigroup.com/wp-content/uploads/2019/09/Green-Shield-1-150x150.jpg",
        thumbnailWidth: 120,
        thumbnailHeight: 120,
      },
      {
        src:
          "https://rosatigroup.com/wp-content/uploads/2019/09/Green-Shield-2.jpg",
        thumbnail:
          "https://rosatigroup.com/wp-content/uploads/2019/09/Green-Shield-2-150x150.jpg",
        thumbnailWidth: 120,
        thumbnailHeight: 120,
      },
    ],
    keywords: ["Health", "Dental", "Benefits", "Insurance"],
    employees: "1001-5000",
    createdAt: "09/12/2020 02:59:32 AM",
  },

  "highline-mushrooms": {
    companyName: "Highline Mushrooms",
    description:
      "Highline Mushrooms was founded in 1961 by Dr. Murray O’Neil. We have four growing facilities (two in Leamington, Ontario, one in Kingsville, Ontario, and one in Wellington, Ontario) and a distribution centre based in Montreal, Quebec. From humble beginnings, we have grown to become the largest mushroom grower in Canada.",
    address: "506 Mersea Road 5, Leamington, Ontario N8H 3V5 Canada",
    logo: "https://www.highlinemushrooms.com/images/highline_logo.png",
    industry: "Food Crops",
    website: "https://www.highlinemushrooms.com/en/index.php",
    keywords: ["Food Products", "Distribution", "Cultivation", "Wholesale"],
    createdAt: "09/24/2020 09:47:54 PM",
    images: [
      {
        src: "https://photos.prnewswire.com/prnfull/20160401/350385",
        thumbnail: "/assets/images/companies/highline_tb_2.jpeg",
        thumbnailWidth: 120,
        thumbnailHeight: 120,
      },
      {
        src: "https://okotoksonline.com/images/stories/ag-news/528ec80472.jpeg",
        thumbnail: "/assets/images/companies/highline_tb_1.jpeg",
        thumbnailWidth: 120,
        thumbnailHeight: 120,
      },
      {
        src:
          "https://i.cbc.ca/1.3752722.1473335173!/fileImage/httpImage/image.jpg_gen/derivatives/16x9_780/highline-mushrooms.jpg",
        thumbnail: "/assets/images/companies/highline_tb_3.jpeg",
        thumbnailWidth: 120,
        thumbnailHeight: 120,
      },
      {
        src: "https://www.windsorstar.com/cms/binary/3093112.jpg?size=640x420",
        thumbnail: "/assets/images/companies/highline_tb_4.jpeg",
        thumbnailWidth: 120,
        thumbnailHeight: 120,
      },
      {
        src:
          "https://images.thestar.com/pESXThDiBX9g-NdrjoVj4RzzzDw=/1086x724/smart/filters:cb(2700061000)/https://www.thestar.com/content/dam/thestar/news/immigration/2017/10/30/canadian-mushroom-growers-push-for-permanent-residency-for-migrant-workers/mushroom_workers.jpg",
        thumbnail: "/assets/images/companies/highline_tb_5.jpeg",
        thumbnailWidth: 120,
        thumbnailHeight: 120,
      },
    ],
    employees: "1600",
  },

  "ford-motor-company": {
    companyName: "Ford Motor Company",
    description:
      "Ford Motor Company of Canada, Limited was founded on August 17, 1904, for the purpose of manufacturing and selling Ford automobiles in Canada and the British Empire. It was originally known as the Walkerville Wagon Works and was located in Walkerville, Ontario.",
    address: "1 The Canadian Rd, Oakville, ON L6H 1A7, Canada",
    logo:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/Ford_logo_flat.svg/180px-Ford_logo_flat.svg.png",
    industry: "Auto Engine Manufacturing",
    website: "https://www.ford.ca/",
    isHiring: true,
    images: [
      {
        src:
          "https://upload.wikimedia.org/wikipedia/commons/f/fe/Ford_Oakville_Assembly.JPG",
        thumbnail:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Ford_Oakville_Assembly.JPG/240px-Ford_Oakville_Assembly.JPG",
        thumbnailWidth: 120,
        thumbnailHeight: 120,
      },
    ],
    createdAt: "09/26/2020 03:00:42 AM",
  },

  "caesars-windsor": {
    companyName: "Caesars Windsor",
    description:
      "Caesars Windsor in Windsor, Ontario, Canada is one of four casinos in the Detroit–Windsor area and was opened in 1994 on the waterfront of the Detroit River. Owned by the Government of Ontario (through the Ontario Lottery and Gaming Corporation), it is operated by Caesars Entertainment.",
    address: "377 Riverside Drive East Windsor, Ontario N9A 7H7",
    logo:
      "https://www.caesars.com/content/dam/wcl/Logos/Caesars-Windsor-Header-Logo.png",
    logoBg: "#000",
    industry: "Casino",
    website: "https://www.caesars.com/caesars-windsor",
    images: [
      {
        src: "https://cf.bstatic.com/images/hotel/max1280x900/661/66148232.jpg",
        thumbnail: "/assets/images/companies/caesars_tb_1.jpeg",
        thumbnailWidth: 120,
        thumbnailHeight: 120,
      },
      {
        src:
          "https://blackburnnews.com/wp-content/uploads/2019/03/D1euwkOX0AIsQYb.jpg",
        thumbnail: "/assets/images/companies/caesars_tb_2.jpeg",
        thumbnailWidth: 120,
        thumbnailHeight: 120,
      },
    ],
    createdAt: "06/22/2020 04:12:29 PM",
  },

  "fca-canada": {
    companyName: "Fiat Chrysler Automobiles",
    description:
      "FCA Canada Inc., formerly Chrysler Canada, is the wholly owned subsidiary of Fiat Chrysler Automobiles operating in Canada. Incorporated in 1925, the 'Chrysler Corporation of Canada' gained complete control of a Maxwell-Chalmers plant in Windsor, Ontario that had been used to manufacture some Chrysler models in the previous year.",
    address: "1 Riverside Drive, Windsor, Ontario, Canada",
    logo:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Fiat_Chrysler_Automobiles_logo.svg/200px-Fiat_Chrysler_Automobiles_logo.svg.png",
    industry: "Automotive Assembly",
    website:
      "https://www.fcagroup.com/stories/northamerica/en-us/Pages/default.aspx",
    isHiring: true,
    images: [
      {
        src:
          "https://s3-prod-canada.autonews.com/s3fs-public/FCAearnings-MAIN_i.jpg",
        thumbnail: "/assets/images/companies/fca_tb_1.jpeg",
        thumbnailWidth: 120,
        thumbnailHeight: 120,
      },
      {
        src:
          "https://steelguru.com/uploads/news/fca-fiat-chrysler-automobiles-september-sales-auto-sector-us-auto-news-us_37158.jpg",
        thumbnail: "/assets/images/companies/fca_tb_2.jpeg",
        thumbnailWidth: 120,
        thumbnailHeight: 120,
      },
      {
        src:
          "https://assets.bwbx.io/images/users/iqjWHBFdfxIU/ie6f_J9umNX0/v0/1000x-1.jpg",
        thumbnail: "/assets/images/companies/fca_tb_3.jpeg",
        thumbnailWidth: 120,
        thumbnailHeight: 120,
      },
    ],
    createdAt: "09/29/2020 06:55:03 AM",
  },

  "sutherland-group-canada": {
    companyName: "Sutherland Group Canada",
    description:
      "Sutherland Global Services Inc. operates as a digital transformation company. The Company rethinks and rebuilds processes for the digital age by combining the speed and insight of design thinking with the scale and accuracy of data analytics.",
    address: "500 Ouellette Ave, Windsor, ON N9A 1B7, Canada",
    logo:
      "https://media.glassdoor.com/sqll/25705/sutherland-squarelogo-1489522308091.png",
    industry: "Call Centre",
    website: "https://www.sutherlandglobal.com/",
    images: [
      {
        src:
          "https://media.glassdoor.com/l/61/d7/ba/b9/sutherland-global-services.jpg",
        thumbnail: "/assets/images/companies/sutherland_tb_1.jpeg",
        thumbnailWidth: 120,
        thumbnailHeight: 120,
      },
    ],
    createdAt: "10/01/2020 10:58:29 AM",
  },
};
